/**
 * AttachmentsColumn Component
 * Displays attachments with preview and download functionality
 *
 * @param {Object} props
 * @param {Array} props.attachments - Array of attachment objects
 * @param {Set} props.downloadingItems - Set of item IDs currently being downloaded
 * @param {Function} props.onPreview - Handler for previewing/opening an attachment
 * @param {Function} props.onDownload - Handler for downloading an attachment
 */
const AttachmentsColumn = ({
  attachments = [],
  downloadingItems = new Set(),
  onPreview,
  onDownload,
}) => {
  if (attachments.length === 0) {
    return <span className="approval-summary-td-content">—</span>
  }

  return (
    <div className="as-table-cell-scroll">
      {attachments.map((att, idx) => {
        const attKey = att.id || att.urn || `att-${idx}`
        const isDownloading = downloadingItems.has(attKey)

        return (
          <div
            key={attKey}
            className="as-attachment-compact"
          >
            <div
              onClick={() => onPreview && onPreview(att)}
              style={{
                flex: 1,
                cursor: 'pointer',
                minWidth: 0
              }}
            >
              <span className="as-attachment-name-compact" title={att.name}>
                {att.name || 'Unnamed'}
              </span>
            </div>
            <button
              onClick={(e) => onDownload && onDownload(att, e)}
              disabled={isDownloading}
              className="as-download-icon-btn"
              title="Download"
            >
              {isDownloading ? '⏳' : '⬇'}
            </button>
          </div>
        )
      })}
    </div>
  )
}

export default AttachmentsColumn
